<ng-container [formGroup]="formGroup">
    <div>
        <div class="hotizontal-container vertical-align">
            <label class="control-label right-buffer"> Planned Time </label>
            <span
                class="btn btn-xs btn-pill left-buffer"
                style="margin-bottom: 5px"
                (click)="setTimeToNow()"
            >
                Set to now
            </span>
        </div>
        <field-validation-indicator
            validatorFormControlName="airspaceDate"
            [noun]="'field'"
            [placement]="'left'"
            class="pull-right"
        ></field-validation-indicator>
        <div class="input-group">
            <input
                class="form-control"
                type="text"
                required
                #datepicker="bsDatepicker"
                bsDatepicker
                formControlName="airspaceDate"
                [readonly]="working"
                [isDisabled]="working"
                [bsConfig]="{ adaptivePosition: false }"
                [placement]="'right'"
            />
            <span
                *ngIf="!working"
                class="input-group-addon btn-default"
                (click)="datepicker.toggle()"
                [attr.aria-expanded]="datepicker.isOpen"
            >
                <i class="glyphicon glyphicon-calendar"></i>
            </span>
        </div>
        <div
            class="horizontal-container vertical-align"
            style="width: fit-content"
        >
            <timepicker
                formControlName="airspaceDate"
                [hourStep]="1"
                [minuteStep]="1"
                [showMeridian]="false"
                [showSpinners]="false"
                [readonlyInput]="working"
            >
            </timepicker>
            &nbsp;{{ timeZoneAbbreviation$ | async }}
        </div>
    </div>
    <div>
        <label class="control-label"> Duration </label>
        <field-validation-indicator
            validatorFormControlName="airspaceDuration"
            [noun]="'field'"
            [placement]="'left'"
            class="pull-right"
        ></field-validation-indicator>
        <duration
            formControlName="airspaceDuration"
            [readonly]="working"
            [showHour]="true"
            [showMinute]="false"
            [showSecond]="false"
        >
        </duration>
    </div>
    <div>
        <label class="control-label"> Ruleset </label>
        <field-validation-indicator
            validatorFormControlName="airspaceRuleset"
            [noun]="'field'"
            [placement]="'left'"
            class="pull-right"
        ></field-validation-indicator>
        <ng-select
            [items]="airspaceRulesetList"
            [readonly]="working"
            [clearable]="false"
            bindLabel="name"
            appendTo="body"
            formControlName="airspaceRuleset"
        >
        </ng-select>
    </div>
    <div class="bottom-buffer">
        <label class="control-label"> Maximum Height </label>
        <field-validation-indicator
            validatorFormControlName="airspaceHeight"
            [noun]="'field'"
            [placement]="'left'"
            class="pull-right"
        ></field-validation-indicator>
        <div class="input-group">
            <input
                name="maximumHeight"
                type="number"
                class="form-control"
                placeholder="The maximum flight height of the mission above ground level"
                min="0"
                step="1"
                formControlName="airspaceHeight"
                [readonly]="working"
            />
            <span class="input-group-addon">ft AGL</span>
        </div>
    </div>
    <div *ngIf="radius" class="bottom-buffer">
        <label class="control-label"> Check Radius </label>
        <field-validation-indicator
            validatorFormControlName="radius"
            [noun]="'field'"
            [placement]="'left'"
            class="pull-right"
        ></field-validation-indicator>
        <div class="input-group">
            <input
                name="radius"
                type="number"
                class="form-control"
                placeholder="The radius of the check area"
                min="1"
                step="1"
                formControlName="radius"
                [readonly]="working"
            />
            <span class="input-group-addon">m</span>
        </div>
    </div>
    <!-- Using a label here to bypass the map style overrides for buttons -->
    <ng-container *ngIf="!autoSave">
        <label
            *ngIf="!working && !formGroup.invalid"
            type="button"
            class="btn btn-primary btn-sm btn-block"
            (click)="update()"
        >
            Update
        </label>
        <label
            *ngIf="working || formGroup.invalid"
            type="button"
            class="btn btn-primary btn-sm btn-block disabled"
            style="color: #fff !important"
            (click)="update()"
            [tooltip]="
                formGroup.controls.airspaceDuration.invalid
                    ? 'The check duration has to be more than 0 and less than 24 hours'
                    : formGroup.controls.airspaceDate.invalid
                    ? 'The selected date and time is in the past'
                    : ''
            "
            placement="left"
        >
            Update
        </label>
    </ng-container>
</ng-container>
